<template>
	<div id="auth_page" style="width: 100%;background-color:e60012;">
			<img src="/img/authpage.jpg" width="100%"/>
			<div style="position: absolute;bottom: 3rem;width: 100px;text-align: center;left:50%;margin-left: -50px;background: rgba(0, 0, 0, 0.3);border-radius: 1.239994rem;color:#FFFFFF;">授权中</div>
			</div>
</template>

<script>
	import {api_user} from '@/common/Request.js';
		export default {
		data () {
		  return {
		    value: '',
			user_token:''
		  }
		},
		mounted(){
			//document.getElementById("auth_page").style.height=document.documentElement.clientHeight+"px";
			//console.log(document.getElementById("auth_page").style.height);
			if(this.$route.query.code!=null){
				if(!this.$cookies.isKey("user_token")||this.$cookies.get("user_token")==undefined)
				{
					this.usertokencheck();
				}
				else{
					
					this.$router.push("/");
				}
			}
			else{
				this.$router.push("/");
			}
		},
		methods:{
			usertokencheck()
			{
					api_user.loginByWeixinCode(this.$route.query.code).then(response => {
				    console.log(response.data);
					if(response.code==0)
					{
						this.user_token=response.data.token;
						this.$cookies.set("user_token",response.data.token);
						this.$cookies.set("mobilephone",response.data.mobile);
						this.$cookies.set("userId",response.data.userId);
						console.log("gotobefore:",this.$cookies.get("beforeLoginUrl"));
						this.$router.push(this.$cookies.get("beforeLoginUrl"));
					}
					else if(response.code==-1999){
						this.$router.push({ name: 'auth_binding', query: { openid: response.data.openid }});
					}
	
				})
				.catch(err=>{
					console.log(err);
				})
			}
		}
	}
</script>

<style>
</style>
